import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { Feature } from 'src/WebApiController';

export const useHasWasteSaleFeature = () => {
  return useUserHasFeature(Feature.WasteSale);
};
